<div class="stepper-footer">
	<div *ngFor="let dpaButton of documentPaButtons">
		<button mat-button type="button" [class]="dpaButton.styleClass" (click)="emitEvent(dpaButton, $event)"  [disabled]="dpaButton.disabled">{{ dpaButton.label }}</button>
	</div>
</div>